<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><a id="pvi"></a> I am greatly indebted to many published and unpublished diaries, letters and journals of women who settled the West. I hope their strong, honest voices can be heard in this book.</p></blockquote>
<blockquote><p class="first">I’m grateful to Tony Wolk and Dee Anne Westbrook, who read the manuscript with care and perception; and to Ed, who gave me time, encouragement, applause.</p></blockquote>
<blockquote><p class="first">I must also thank my dad, who introduced me to the public library, and to the panorama of the real and imagined West.</p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?b8a7c218